import makeStyles from '@mui/styles/makeStyles';
import {expiryTier, expiryTiers, getTimeRemaining, timeRemainingMessage} from "business/matching";
import {Clock} from "lucide-react";
import React from "react";
import {useTranslation} from "react-i18next";
import {font, match, type} from "common/tokens";

const TIER_COLORS = {
  [expiryTiers.OK]: match.EXPIRY_OK,
  [expiryTiers.SOON]: match.EXPIRY_SOON,
  [expiryTiers.URGENT]: match.EXPIRY_URGENT,
};

const useStyles = makeStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    ...type.meta,
    fontWeight: font.REGULAR,
    color: match.CHIP_MUTED_FG,
  },
  duration: {
    fontWeight: font.BOLD,
  },
});

const ExpiryDurationMessage = ({timeStamp, expiryHours, long = false}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  const remaining = getTimeRemaining(timeStamp, expiryHours);

  return (
    <div className={classes.row}>
      <Clock size={12} strokeWidth={2.5}/>
      <span>
        {long ? t('matchWillAutoExpireIn') : t('expiresIn')}{' '}
        <span className={classes.duration} style={{color: TIER_COLORS[expiryTier(remaining)]}}>
          {timeRemainingMessage(remaining)}
        </span>
      </span>
    </div>
  );
};

export default ExpiryDurationMessage;
